import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const socialLinks = [
    { name: 'Instagram', icon: <Instagram size={24} />, url: 'https://instagram.com/jfraifamilycatering', color: '#E4405F' },
    { name: 'Facebook', icon: <Facebook size={24} />, url: 'https://facebook.com/jfraifamilycatering', color: '#1877F2' },
    { name: 'Twitter', icon: <Twitter size={24} />, url: 'https://twitter.com/jfraifamilycatering', color: '#1DA1F2' },
  ];

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Catering', path: '/catering' },
    { name: 'Event Planning', path: '/events' },
    { name: 'Types of Events', path: '/event-types' },
    { name: 'Decorations', path: '/decorations' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <footer className="bg-gradient-to-br from-[#8b4513] to-[#6b4423] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div>
            <h3 className="text-3xl font-bold mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              JFRAI Family
            </h3>
            <p className="text-white/80 mb-4">
              Family-owned and operated catering & event planning specializing in American, Southern & Caribbean cuisine. We create personalized events, farm-to-table menus, and custom gifts—from backdrops and décor to videography, game nights & murder mystery dinners. Prices are estimates and may change depending on the specifics needed.
            </p>
            <div className="space-y-2">
              <div className="flex items-center gap-2">
                <Phone size={16} />
                <span className="text-sm">(240) 605-4915</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail size={16} />
                <span className="text-sm">info@jfraifamilycatering.com</span>
              </div>
              <div className="flex items-center gap-2">
                <MapPin size={16} />
                <span className="text-sm">Serving the Greater Metro Area</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xl font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {quickLinks.slice(0, 4).map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link.path} 
                    className="text-white/80 hover:text-white transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xl font-bold mb-4">Services</h4>
            <ul className="space-y-2">
              {quickLinks.slice(4, 8).map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link.path} 
                    className="text-white/80 hover:text-white transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h4 className="text-xl font-bold mb-4">Follow Us</h4>
            <p className="text-white/80 mb-4 text-sm">
              Stay connected for updates, specials, and event highlights!
            </p>
            <div className="flex gap-3 mb-4">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-all hover:scale-110"
                  aria-label={`Follow us on ${social.name}`}
                  data-testid={`footer-social-${social.name.toLowerCase()}`}
                >
                  {social.icon}
                </a>
              ))}
            </div>
            <p className="text-sm text-white/80">
              Tag us <span className="font-bold">#JFRAICatering</span>
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 mt-8 pt-8 text-center">
          <p className="text-white/60 text-sm">
            © {new Date().getFullYear()} JFRAI Family Catering & Event Planning. All rights reserved.
          </p>
          <p className="text-white/60 text-sm mt-2">
            Family-owned and operated catering & event planning specializing in American, Southern & Caribbean cuisine. We create personalized events, farm-to-table menus, and custom gifts—from backdrops and décor to videography, game nights & murder mystery dinners. Prices are estimates and may change depending on the specifics needed.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
